export default __webpack_public_path__ + "static/media/linkedin.66635d11.svg";